import React, { useEffect, useState } from 'react';
import Input from '../input/Input';

interface RadioButtonGroupProps {
  options: RadioButtonOption[];
  defaultOptionValue?: string;
  onChange: (value: RadioButtonOption) => void;
  disabled: boolean;
}

const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({ options, defaultOptionValue, onChange, disabled }) => {
  const [selectedOption, setSelectedOption] = useState(
    options.find((x) => x.value == defaultOptionValue) || options[0],
  );

  const handleChange = (newValue: string) => {
    setSelectedOption(options.find((x) => x.value == newValue));
  };

  useEffect(() => {
    onChange(selectedOption);
  }, [selectedOption]);

  return (
    <div>
      {options.map((option) => (
        <React.Fragment key={option.value}>
          <RadioButton
            label={option.label}
            value={option.value}
            description={option.description}
            checked={selectedOption.value === option.value}
            onChange={handleChange}
            disabled={disabled}
          />
          {option.additionalInputBelow && selectedOption.value === option.value && (
            <Input
              type={'text'}
              value={option.additionalInputValue}
              fullWidth={false}
              onChange={(e) => {
                // set additional input value for this option in state
                const { value } = e.target;
                setSelectedOption({ ...selectedOption, additionalInputValue: value });
              }}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export interface RadioButtonOption {
  label: string;
  value: string;
  description?: string;
  additionalInputBelow?: boolean;
  additionalInputValue?: string;
}

interface RadioButtonProps {
  label: string;
  value: string;
  description?: string;
  checked: boolean;
  onChange: (value: string) => void;
  disabled: boolean;
}

const RadioButton: React.FC<RadioButtonProps> = ({ label, value, description, checked, onChange, disabled }) => (
  <label className={`radio-button__label ${description ? 'radio-button__label--with-description' : ''}`}>
    <input
      className="radio-button__input"
      type="radio"
      value={value}
      checked={checked}
      disabled={disabled}
      onChange={() => onChange(value)}
    />
    {description ? (
      <span>
        <span className="radio-button__title">{label}</span>
        <span className="radio-button__description">{description}</span>
      </span>
    ) : (
      <span>{label}</span>
    )}
  </label>
);

export default RadioButtonGroup;
